<label class="switch">
  <input [disabled]="disabled" [checked]="isOn" (change)="emitChange($event)" [name]="name" type="checkbox" id="togBtn">
  <div class="slider round">
    <span class="on">{{onText}}</span>
    <span class="off">{{offText}}</span>
  </div>
</label>
